import { COACHMARK_HIGHLIGHT_CLASS } from 'src/components/Coachmark';
import { CoachmarkTourKey } from 'src/store/ui/types';
import { pollForElement } from 'src/utils/DomUtils';

// The first client's row-actions button (the Actions column is pinned right).
const FIRST_ROW_ACTIONS_SELECTOR =
  '[row-index="0"] [data-testid="more-actions-menu"]';
const FIRST_ROW_SELECTOR = '.ag-row[row-index="0"]';
const OPEN_MENU_ITEM_SELECTOR = `[class~="${COACHMARK_HIGHLIGHT_CLASS}"]`;
const MENU_REOPEN_POLL_MS = 200;
export const CRM_CLIENTS_TOUR_KEY = 'crmClients' satisfies CoachmarkTourKey;

export const enterCoachmarkRowStep = (): (() => void) => {
  let highlighted: HTMLElement[] = [];

  const cancelPoll = pollForElement(
    () => {
      const rows = Array.from(
        document.querySelectorAll(FIRST_ROW_SELECTOR),
      ).filter((row): row is HTMLElement => row instanceof HTMLElement);
      return rows.length > 0 ? rows : null;
    },
    (rows) => {
      rows.forEach((row) => {
        row.classList.add(COACHMARK_HIGHLIGHT_CLASS);
      });
      highlighted = rows;
    },
  );

  return () => {
    cancelPoll();
    highlighted.forEach((row) => {
      row.classList.remove(COACHMARK_HIGHLIGHT_CLASS);
    });
  };
};

export const createEnterCoachmarkMenuStep =
  (setActive: (active: boolean) => void, isActive: () => boolean) =>
  (): (() => void) => {
    setActive(true);

    const openMenu = (): void => {
      const button = document.querySelector(FIRST_ROW_ACTIONS_SELECTOR);
      if (button instanceof HTMLElement) {
        button.click();
      }
    };

    const frame = requestAnimationFrame(openMenu);

    // The coachmark has no dismiss button, so the tour must stay completable. If
    // the user closes the menu (Escape / click-away) the highlighted "Open portal"
    // item — the only way to finish — is removed from the DOM, leaving the card
    // with no anchor. Re-open the menu whenever it is closed so the card
    // re-anchors and the step can still be completed. The check no-ops while the
    // menu is open.

    const reopenInterval = setInterval(() => {
      if (isActive() && !document.querySelector(OPEN_MENU_ITEM_SELECTOR)) {
        openMenu();
      }
    }, MENU_REOPEN_POLL_MS);

    return () => {
      cancelAnimationFrame(frame);
      clearInterval(reopenInterval);
      setActive(false);
    };
  };
